<script setup>
import { useAccreditation } from '@/composables/useAccreditation'
import { useRouter } from 'vue-router'

// Module 13A — TIDAK ada di daftar literal §Module13A Vue Page (yang cuma
// menyebut [resultId]/index.vue & public-summary.vue), tapi dibutuhkan
// supaya fitur ini benar-benar bisa dinavigasi — halaman minimal untuk
// memilih LPA/Jenis Fasyankes/Unit lalu mulai (atau melanjutkan) sesi
// self-assessment, mengarah ke [resultId]/index.vue.
definePage({
  meta: {
    layout: 'default',
    action: 'self-assess',
    subject: 'Accreditation',
  },
})

const router = useRouter()
const { lpas, jenisFasyankesList, saving, fetchLpas, fetchJenisFasyankes, startSession } = useAccreditation()

const lpaId = ref(null)
const jenisId = ref(null)
const unitId = ref(null)
const error = ref('')

onMounted(async () => {
  await Promise.all([fetchLpas(), fetchJenisFasyankes()])
})

const lpaOptions = computed(() => lpas.value.map(l => ({ title: l.name, value: l.id })))
const jenisOptions = computed(() => jenisFasyankesList.value.map(j => ({ title: j.name, value: j.id })))

async function start() {
  error.value = ''
  try {
    const session = await startSession({ lpa_id: lpaId.value, jenis_fasyankes_id: jenisId.value, unit_id: unitId.value })

    router.push({ name: 'accreditation-self-assessment-result-id', params: { resultId: session.id } })
  } catch (e) {
    error.value = e?.data?.message ?? 'Gagal memulai sesi self-assessment.'
  }
}
</script>

<template>
  <div>
    <h4 class="text-h4 font-weight-bold mb-1">
      Self-Assessment Akreditasi
    </h4>
    <p class="text-body-2 text-medium-emphasis mb-4">
      Pilih LPA, Jenis Fasyankes, dan Unit untuk memulai atau melanjutkan sesi (§9.8)
    </p>

    <VCard max-width="560">
      <VCardText class="pa-6">
        <VAlert
          v-if="error"
          type="error"
          variant="tonal"
          density="compact"
          class="mb-4"
        >
          {{ error }}
        </VAlert>

        <VRow>
          <VCol cols="12">
            <VSelect
              v-model="lpaId"
              :items="lpaOptions"
              label="LPA *"
            />
          </VCol>
          <VCol cols="12">
            <VSelect
              v-model="jenisId"
              :items="jenisOptions"
              label="Jenis Fasyankes *"
            />
          </VCol>
          <VCol cols="12">
            <MasterDataPicker
              v-model="unitId"
              entity="units"
              label="Unit *"
            />
          </VCol>
        </VRow>
      </VCardText>
      <VCardActions class="pa-6 pt-0">
        <VSpacer />
        <VBtn
          color="primary"
          :loading="saving"
          :disabled="!lpaId || !jenisId || !unitId"
          @click="start"
        >
          Mulai / Lanjutkan
        </VBtn>
      </VCardActions>
    </VCard>
  </div>
</template>
